import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import ValleyLogo from '../../assets/images/logo-valley.webp';
import { useLanguage } from '../../LanguageContext';

const footerGroups = [
  {
    title: 'Shop',
    titleEs: 'Comprar',
    links: [
      { label: 'In-stock products', labelEs: 'Productos en existencia', href: '/search?q=*&inStock=true&page=1', internal: true },
      { label: 'Full catalog', labelEs: 'Catálogo completo', href: '/search?q=*', internal: true },
      { label: 'Manufacturers', labelEs: 'Fabricantes', href: '/brands', internal: true },
      { label: 'Request a quote', labelEs: 'Solicitar cotización', href: '/about#contact', internal: true }
    ]
  },
  {
    title: 'Company',
    titleEs: 'Empresa',
    links: [
      { label: 'About us', labelEs: 'Quiénes somos', href: '/about', internal: true },
      { label: 'Our services', labelEs: 'Nuestros servicios', href: '/about#services', internal: true },
      { label: 'Contact', labelEs: 'Contacto', href: '/about#contact', internal: true },
      { label: 'Terms & conditions', labelEs: 'Términos y condiciones', href: '/terms', internal: true },
      { label: 'Privacy policy', labelEs: 'Política de privacidad', href: '/privacy', internal: true }
    ]
  },
  {
    title: 'Resources',
    titleEs: 'Recursos',
    links: [
      { label: 'Insights feed', labelEs: 'Contenido industrial', href: '/insights' },
      { label: 'Articles', labelEs: 'Artículos', href: '/blogs' },
      { label: 'Service guides', labelEs: 'Guías de servicio', href: '/services' },
      { label: 'Product news', labelEs: 'Novedades de productos', href: '/products-news' }
    ]
  }
];

const FooterLink = ({ item, t }) => (
  item.internal
    ? <Link to={item.href}>{t(item.label, item.labelEs)}</Link>
    : <a href={item.href}>{t(item.label, item.labelEs)}</a>
);

const Footer = () => {
  const { t } = useLanguage();

  return (
  <footer className="vs-footer">
    <div className="vs-footer-container">
      <div className="vs-footer-top">
        <div className="vs-footer-brand">
          <img src={ValleyLogo} alt="Valley International Supply" />
          <p>
            {t(
              'Industrial automation products, sourcing support and technical guidance for manufacturers across the Americas.',
              'Productos de automatización industrial, soporte de abastecimiento y orientación técnica para fabricantes en todo el continente americano.'
            )}
          </p>
          <a
            className="vs-footer-social"
            href="https://www.linkedin.com/company/valley-international-supply/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin-in" aria-hidden="true" />
            {t('Follow us on LinkedIn', 'Síganos en LinkedIn')}
          </a>
        </div>

        <div className="vs-footer-links">
          {footerGroups.map((group) => (
            <div key={group.title}>
              <h3>{t(group.title, group.titleEs)}</h3>
              <ul>
                {group.links.map((item) => (
                  <li key={item.label}><FooterLink item={item} t={t} /></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="vs-footer-offices">
        <span>{t('Regional support', 'Soporte regional')}</span>
        <div>
          <p><strong>{t('United States', 'Estados Unidos')}</strong> Brownsville, Texas</p>
          <p><strong>{t('Mexico', 'México')}</strong> Matamoros, Tamaulipas</p>
          <p><strong>{t('Central America', 'Centroamérica')}</strong> San Pedro Sula, Honduras</p>
        </div>
        <a href="mailto:inquiry@valleyintlsupply.com">inquiry@valleyintlsupply.com <b>↗</b></a>
      </div>

      <div className="vs-footer-bottom">
        <p>© {new Date().getFullYear()} Valley International Supply. {t('All rights reserved.', 'Todos los derechos reservados.')}</p>
        <p className="vs-footer-disclaimer">
          {t(
            'Manufacturer names and trademarks belong to their respective owners. Valley International Supply is an independent supplier unless explicitly stated otherwise.',
            'Los nombres y marcas comerciales de los fabricantes pertenecen a sus respectivos propietarios. Valley International Supply es un proveedor independiente, salvo que se indique expresamente lo contrario.'
          )}
        </p>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
